import autarkyMatrix from '@/lib/data/autarky.json' assert { type: 'json' };
import selfConsumptionMatrix from '@/lib/data/selfConsumption.json';

function setRatioProduction(consuption: number, production: number): number {
  return production/consuption*1000;
}

function setRatioBattery(consuption: number, battery: number): number {
  return battery/consuption*1000;
}

function findInMatrix(matrix: Array<Array<number>>, x: number, y: number): number {
  // x-Index suchen
  let xi = Math.ceil(x/0.0625)+1;
  // y-Index suchen
  let yi = Math.ceil(y/0.0625)+1;

  let topLeft = matrix[yi-1][xi-1];
  let topRight = matrix[yi-1][xi];
  let bottomLeft = matrix[yi][xi-1];
  let bottomRights = matrix[yi][xi];

  let xInterpolatedTop = topLeft + (x - matrix[0][xi - 1]) * (topRight - topLeft) / (matrix[0][xi] - matrix[0][xi - 1]);
  let xInterpolatedBottom = bottomLeft + (x - matrix[0][xi - 1]) * (bottomRights - bottomLeft) / (matrix[0][xi] - matrix[0][xi - 1]);

  if (yi > 1) {
    let interpoliert = xInterpolatedTop + (y - matrix[yi - 1][0]) * (xInterpolatedBottom - xInterpolatedTop) / (matrix[yi][0] - matrix[yi - 1][0]);
    return interpoliert;
  }

  return xInterpolatedBottom;
}

/**
 * Calculate the autarky of a household
 *
 * @param production Max energy produced by the PV system in kWp (1 kWp = 1000 kWh/year)
 * @param consuption Energy consumed by the household in kWh/year
 * @param battery Energy stored in the battery in kWh
 * @returns Autarky in percent
 */
export function calculateAutarky(production: number, consuption: number, battery: number): number {
  let ratioProduction = setRatioProduction(consuption, production);
  let ratioBattery = setRatioBattery(consuption, battery);

  return Math.round(findInMatrix(autarkyMatrix, ratioProduction, ratioBattery) * 100);
}

/**
 * Calculate the self consumption of a household
 *
 * @param production Max energy produced by the PV system in kWp (1 kWp = 1000 kWh/year)
 * @param consuption Energy consumed by the household in kWh/year
 * @param battery Energy stored in the battery in kWh
 * @returns Self consumption in percent
 */
export function calculateSelfConsumption(production: number, consuption: number, battery: number): number {
  let ratioProduction = setRatioProduction(consuption, production);
  let ratioBattery = setRatioBattery(consuption, battery);

  return Math.round(findInMatrix(selfConsumptionMatrix, ratioProduction, ratioBattery) * 100);
}


